module.exports = __webpack_public_path__ + "img/buddy_body-wrinkles.bac56d5e.svg";